import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baedec66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Loading association summary data")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Error loading association summary data")
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = { class: "secondary" }

import { watch, onMounted } from "vue";
import AppNodeBadge from "@/components/AppNodeBadge.vue";
import AppRelationBadge from "@/components/AppRelationBadge.vue";
import { Node } from "@/api/node-lookup";
import { getTopAssociations, Association } from "@/api/node-associations";
import { useQuery } from "@/util/composables";

interface Props {
  /** current node */
  node: Node;
  /** selected association category */
  selectedCategory: string;
  /** selected association id */
  selectedAssociation?: Association;
}

interface Emits {
  /** change selected association */
  (event: "select", value?: Association): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssociationsSummary',
  props: {
    node: null,
    selectedCategory: null,
    selectedAssociation: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  /** change selected association */
  (event: "select", value?: Association): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** current node */
  node: Node;
  /** selected association category */
  selectedCategory: string;
  /** selected association id */
  selectedAssociation?: Association;
}





/** get summary association data */
const {
  query: getAssociations,
  data: associations,
  isLoading,
  isError,
} = useQuery(
  async function () {
    /** catch case where no association categories available */
    if (!props.node.associationCounts.length)
      throw new Error("No association info available");

    /** get association data */
    return await getTopAssociations(
      props.node.id,
      props.node.category,
      props.selectedCategory
    );
  },

  /** default value */
  []
);

/** get associations when category changes */
watch(() => props.selectedCategory, getAssociations);

/** get associations on load */
onMounted(getAssociations);

return (_ctx: any,_cache: any) => {
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_unref(isLoading))
    ? (_openBlock(), _createBlock(_component_AppStatus, {
        key: 0,
        code: "loading"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }))
    : (_unref(isError))
      ? (_openBlock(), _createBlock(_component_AppStatus, {
          key: 1,
          code: "error"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("span", null, "Top " + _toDisplayString(_unref(associations).length) + " association(s)", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(associations), (association, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "result"
            }, [
              _createVNode(_component_AppFlex, {
                direction: "col",
                "h-align": "left",
                gap: "small",
                class: "details"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(AppNodeBadge, {
                      node: __props.node,
                      link: false
                    }, null, 8, ["node"]),
                    _hoisted_4,
                    _createVNode(AppRelationBadge, {
                      relation: association.relation
                    }, null, 8, ["relation"]),
                    _hoisted_5,
                    _createVNode(AppNodeBadge, {
                      node: association.object,
                      breadcrumb: { node: __props.node, relation: association.relation }
                    }, null, 8, ["node", "breadcrumb"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(association.supportCount) + " piece(s) of supporting evidence", 1)
                  ])
                ]),
                _: 2
              }, 1024),
              _withDirectives(_createVNode(_component_AppButton, {
                class: "evidence",
                text: "Evidence",
                "aria-pressed": association.id === __props.selectedAssociation?.id,
                icon: association.id === __props.selectedAssociation?.id ? 'check' : 'flask',
                color: 
          association.id === __props.selectedAssociation?.id ? 'primary' : 'secondary'
        ,
                onClick: ($event: any) => (
          emit(
            'select',
            association.id === __props.selectedAssociation?.id ? undefined : association
          )
        )
              }, null, 8, ["aria-pressed", "icon", "color", "onClick"]), [
                [_directive_tooltip, 
          association.id === __props.selectedAssociation?.id
            ? 'Viewing supporting evidence. Click again to hide.'
            : 'View supporting evidence for this association'
        ]
              ])
            ]))
          }), 128))
        ], 64))
}
}

})